import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UpdateBannerProps {
  onReload: () => void;
}

/**
 * Sticky top banner shown when a new app version is available.
 */
const UpdateBanner: React.FC<UpdateBannerProps> = ({ onReload }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Full-screen backdrop — blocks all interaction with the rest of the app */}
      <div className="fixed inset-0 z-[9998] bg-black/40 backdrop-blur-sm pointer-events-auto" />

      {/* Banner */}
      <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center gap-3 bg-indigo-600 text-white px-4 py-2.5 shadow-lg text-sm">
        <div className="flex items-center gap-2">
          <RefreshCw className="w-4 h-4 shrink-0" />
          <span>
            {t('update.banner.message', {
              defaultValue: 'A new version of the app is available.',
            })}
          </span>
          <button
            onClick={onReload}
            className="ml-2 underline underline-offset-2 font-semibold hover:text-indigo-200 transition-colors"
          >
            {t('update.banner.refresh', { defaultValue: 'Refresh now' })}
          </button>
        </div>
      </div>
    </>
  );
};

export default UpdateBanner;
